import * as stylex from '@stylexjs/stylex';

/**
 * KEYFRAMES
 */






/**
 * MEDIA QUERIES
 */
const MEDIA_1200 = '@media (max-width: 1200px)';
const MEDIA_992 = '@media (max-width: 992px)';
const MEDIA_768 = '@media (max-width: 768px)';
const MEDIA_480 = '@media (max-width: 480px)';

export const styles = stylex.create({
    aiModelsPage: {
        maxWidth: '100%',
        marginInline: 'auto',
        paddingInline: { default: 0, [MEDIA_768]: 'var(--spacing-sm)' },
    },
    backLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        color: {
            default: 'var(--text-secondary)',
            ':hover': 'var(--primary)',
        },
        textDecoration: 'none',
        fontSize: 'var(--font-size-sm)',
        marginBottom: 'var(--spacing-md)',
        transitionProperty: 'color',
        transitionDuration: 'var(--transition-fast)',
    },
    pageTitle: {
        fontSize: { default: '3rem', [MEDIA_768]: '2rem' },
        fontWeight: 800,
        margin: 0,
        color: 'var(--text-primary)',
        backgroundImage: 'linear-gradient(135deg, var(--primary), var(--accent))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
    },
    /* Hero Section */
    heroSection: {
        position: 'relative',
        minHeight: { default: '600px', [MEDIA_768]: '400px', [MEDIA_480]: '350px' },
        borderRadius: 'var(--radius-xl)',
        marginBottom: 'var(--spacing-3xl)',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        padding: { [MEDIA_768]: 'var(--spacing-xl)', [MEDIA_480]: 'var(--spacing-lg)' },
    },
    aiModelsHeroAnimated: {
        position: 'relative',
        backgroundImage: `linear-gradient(135deg,
            var(--bg-card) 0%,
            rgba(59, 130, 246, 0.02) 15%,
            rgba(16, 185, 129, 0.02) 35%,
            rgba(255, 107, 107, 0.02) 55%,
            rgba(139, 92, 246, 0.02) 75%,
            var(--bg-card) 100%)`,
        borderRadius: 'var(--radius-xl)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'var(--border)',
        overflow: 'hidden',
        '::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `radial-gradient(circle at 15% 40%, rgba(59, 130, 246, 0.03) 0%, transparent 50%),
                             radial-gradient(circle at 85% 60%, rgba(16, 185, 129, 0.03) 0%, transparent 50%),
                             radial-gradient(circle at 40% 20%, rgba(255, 107, 107, 0.02) 0%, transparent 50%),
                             radial-gradient(circle at 60% 80%, rgba(139, 92, 246, 0.02) 0%, transparent 50%)`,
            opacity: 1,
        },
    },
    heroContent: {
        position: 'relative',
        zIndex: 2,
        padding: { default: 'var(--spacing-3xl)', [MEDIA_768]: 'var(--spacing-xl)', [MEDIA_480]: 'var(--spacing-lg)' },
        maxWidth: { default: '600px', [MEDIA_768]: '100%' },
        color: 'var(--text-primary)',
    },
    /* Category Sections */
    categorySection: {
        marginBottom: 'var(--spacing-3xl)',
        scrollMarginTop: '2rem',
    },
    categoryHeader: {
        display: 'flex',
        gap: 'var(--spacing-lg)',
        flexDirection: { [MEDIA_768]: 'column' },
        padding: { [MEDIA_768]: 'var(--spacing-lg)' },
    },
    categoryIcon: {
        color: 'var(--primary)',
        flexShrink: 0,
        marginTop: 'var(--spacing-xs)',
    },
    categoryTitle: {
        fontSize: 'var(--font-size-2xl)',
        fontWeight: 600,
        color: 'var(--text-primary)',
        marginBlock: '0 var(--spacing-sm)',
        position: 'relative',
    },
    /* Grid */
    modelsGrid: {
        display: 'grid',
        gridTemplateColumns: {
            default: 'repeat(auto-fill, 320px)',
            [MEDIA_1200]: 'repeat(auto-fill, 300px)',
            [MEDIA_992]: 'repeat(auto-fill, 280px)',
            [MEDIA_768]: '1fr'
        },
        gap: { default: 'var(--spacing-lg)', [MEDIA_1200]: 'var(--spacing-md)' },
        marginTop: 'var(--spacing-xl)',
        justifyContent: 'flex-start',
    },
    /* Model Card */
    modelCard: {
        backgroundColor: 'var(--bg-card)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'var(--border)',
        borderRadius: 'var(--radius-lg)',
        padding: { default: 'var(--spacing-lg)', [MEDIA_768]: 'var(--spacing-md)' },
        textDecoration: 'none',
        color: 'var(--text-primary)',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-normal)',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        backdropFilter: 'blur(4px)',
        transform: {
            default: 'none',
            ':hover': 'translateY(-4px)',
        },
        boxShadow: {
            default: 'none',
            ':hover': 'var(--shadow-lg)',
        },
        '::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            backgroundImage: 'linear-gradient(90deg, var(--primary), var(--accent))',
            transform: 'scaleX(0)',
            transitionProperty: 'transform',
            transitionDuration: 'var(--transition-normal)',
        },
    },
    modelCardHoverActive: {
        borderColor: 'var(--primary)',
        '::before': { transform: 'scaleX(1)' }
    },
    modelCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 'var(--spacing-md)',
    },
    modelCardIcon: {
        width: '48px',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 'var(--radius-lg)',
        backgroundColor: 'var(--bg-secondary)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'var(--border)',
        boxShadow: 'var(--shadow-sm)',
        color: 'var(--primary)',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-normal)',
    },
    // ADDED: The missing property
    modelCardContent: {
        flex: 1,
    },
    modelBadge: {
        backgroundColor: 'var(--accent)',
        color: 'var(--text-on-accent)',
        paddingBlock: 'var(--spacing-xs)',
        paddingInline: 'var(--spacing-sm)',
        borderRadius: 'var(--radius-full)',
        fontSize: 'var(--font-size-xs)',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
    },
    modelTitle: {
        fontSize: 'var(--font-size-lg)',
        fontWeight: 600,
        marginBlock: '0 var(--spacing-md)',
        color: 'var(--text-primary)',
    },
    modelDescription: {
        fontSize: 'var(--font-size-sm)',
        color: 'var(--text-secondary)',
        lineHeight: 1.6,
        marginBottom: 'var(--spacing-lg)',
    },
    modelHighlights: {
        listStyleType: 'none',
        padding: 0,
        marginBlock: '0 var(--spacing-lg)',
    },
    highlightItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        color: 'var(--text-secondary)',
        marginBottom: 'var(--spacing-xs)',
        fontSize: 'var(--font-size-sm)',
        '::before': {
            content: '"✓"',
            color: 'var(--success)',
            fontWeight: 'bold',
            fontSize: 'var(--font-size-sm)',
        }
    },
    modelCardFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: 'var(--spacing-md)',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'var(--border)',
    },
    creditCost: {
        fontSize: 'var(--font-size-sm)',
        fontWeight: 600,
        color: 'var(--success)',
        backgroundColor: 'hsla(var(--hue-success), 50%, 50%, 0.1)',
        paddingBlock: 'var(--spacing-xs)',
        paddingInline: 'var(--spacing-sm)',
        borderRadius: 'var(--radius-sm)',
    },
    learnMore: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        color: 'var(--primary)',
        fontWeight: 500,
        fontSize: 'var(--font-size-sm)',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-normal)',
    },
    learnMoreHover: {
        transform: 'translateX(4px)',
    }
});